export default {
  None: 0,
  New: 10,
  InProgress: 20,
  Completed: 30,
  Closed: 40
}
